import toastMsg from '../../lib/toastMsg';

type ToastMsgType = {
  success: (message: string) => void;
  info: (message: string) => void;
  error: (message: string, error?: any) => void;
};

const useToastMsg = (): ToastMsgType => {
  const success = (message: string): void => {
    toastMsg.success(message);
  };

  const info = (message: string): void => {
    toastMsg.info(message);
  };

  const error = (message: string, error?: any): void => {
    toastMsg.error(message, error);
  };

  return { success, info, error };
};

export default useToastMsg;
